var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21094 8.99997H12.3809L7.50094 13.88C7.11094 14.27 7.11094 14.91 7.50094 15.3C7.89094 15.69 8.52094 15.69 8.91094 15.3L15.5009 8.70997C15.8909 8.31997 15.8909 7.68997 15.5009 7.29997L8.92094 0.699971C8.53094 0.309971 7.90094 0.309971 7.51094 0.699971C7.12094 1.08997 7.12094 1.71997 7.51094 2.10997L12.3809 6.99997H1.21094C0.660937 6.99997 0.210938 7.44997 0.210938 7.99997C0.210938 8.54997 0.660937 8.99997 1.21094 8.99997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6ad3a7ce10754078c5bf4f59b87706cb.svg";
export { ForwardRef as ReactComponent };